import React from 'react'
import Navbar from '../defaultComponents/Navbar.jsx'
import Footer from '../defaultComponents/Footer.jsx'

import ENGTimesheetsFull from './ENGTimesheetsFull.jsx'
export default function ENGTimesheetsPage() {
  return (
    <>
    <Navbar />
    <div className="all-page-background" style={{background: "#F8F8F8", width: "100%", height: "100%"}}>
      <div className="default-page-wrapper">
        <ENGTimesheetsFull division={"Engineering"} viewer={"engineering"}/>
      </div>
    <Footer />
    </div>
    </>
  )
}
